import { createSelector } from 'reselect';

export const selectAnalyticsState = (state) => state.analytics;

export const selectTriggerAnalyticsState = createSelector(
  selectAnalyticsState,
  ({ loading, error, success }) => ({ loading, error, success })
);
